<template lang="pug">
div
    //- list of counted stock
    .box
        .box-header
            h3 Counted Stocks
            small Stock quantity will be updated when mark completed

        //- form to validate stock quantity
        form
            v-client-table(
                :data="stocks",
                :columns="columns",
                :options="options",
                ref="datatable",
            )
                template(slot="counted_quantity" slot-scope="props")
                    div(v-if="canEdit")
                        input.w-sm.form-control(
                            v-show="canEdit",
                            :class="{ 'has-error': errors.has('quantity', `quantity_${props.row.stock_id}`) }",
                            type="text",
                            name="quantity",
                            autocomplete="off",
                            placeholder="Enter Qty",
                            v-validate="'required|decimal:2|min_value:0'",
                            :data-vv-scope="`quantity_${props.row.stock_id}`",
                            :id="`quantity_${props.row.stock_id}`",
                            :key="`quantity_${props.row.stock_id}`",
                            @input="updateCountedStock({stock_id: props.row.stock_id, attr: 'counted_quantity', value: $event.target.value})",
                            :value="props.row.counted_quantity"
                        )
                        span.text-danger(v-if="errors.has('quantity', `quantity_${props.row.stock_id}`)")
                            | {{ errors.first('quantity', `quantity_${props.row.stock_id}`) }}

                    span(v-else) {{ props.row.counted_quantity  }}
                
                template(slot="afterTable")
                    .row.p-a(v-if="canEdit")
                        .col-md-6.col-md-offset-6
                            .form-group
                                label.m-b-0._500 Select Stock to Count
                                stock-inventory-selector(
                                    placeholder="Select stock",
                                    :outlet-id="stockCheck.outlet_id",
                                    @select="onSelectStock"
                                    page="stock_check"
                                )
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import stockCheckMixin from './stock-check-mixin';

export default {
    inject: ['$validator'],

    mixins: [stockCheckMixin],

    data() {
        return {
            checkedAll: false,
            columns: [
                'name',
                'sku',
                'barcode',
                'expected_quantity',
                'counted_quantity',
                'difference',
                'reasons',
                'action',
            ],
            options: {
                filterable: false,
                sortable: [],
                columnsClasses: {
                    action: 'w-xs',
                    reasons: 'text-nowrap',
                    expected_quantity: 'text-center',
                    difference: 'text-center',
                },
                headings: {
                    difference: 'Variance -/+',
                    reasons: 'Variance Reason',
                    action: '',
                },
                perPage: 1000,
                perPageValues: [1000],
                templates: {
                    name: (h, row) => {
                        return row.stock.name;
                    },
                    sku: (h, row) => {
                        return row.stock.sku;
                    },
                    barcode: (h, row) => {
                        return row.stock.barcode;
                    },
                    action: (h, row, index) => {
                        return require('./counted-stock-columns/action.jsx').call(
                            this,
                            h,
                            row,
                        );
                    },
                    difference: (h, row, index) => {
                        return require('./counted-stock-columns/difference.jsx').call(
                            this,
                            h,
                            row,
                        );
                    },
                    reasons: (h, row, index) => {
                        return require('./counted-stock-columns/variance-reasons.jsx').call(
                            this,
                            h,
                            row,
                            index,
                        );
                    },
                },
                skin: 'table m-b-0 b-b',
                uniqueKey: 'stock_id',
            },
        };
    },

    computed: {
        ...mapGetters('stockCheck', [
            'stockCheck',
            'stocks',
            'varianceTypes',
            'findStockIndex',
        ]),

        canUpdate() {
            return this.can(this.permission.SAVE_STOCK_CHECK);
        },
    },

    watch: {
        hasFinalized(newVal) {
            this.$refs.datatable.userControlsColumns = true;

            if (newVal) {
                this.$refs.datatable.userColumnsDisplay = [
                    'name',
                    'sku',
                    'expected_quantity',
                    'counted_quantity',
                    'difference',
                    'reasons',
                ];
            } else {
                this.$refs.datatable.userColumnsDisplay = [
                    'name',
                    'sku',
                    'expected_quantity',
                    'counted_quantity',
                    'difference',
                    'reasons',
                    'action',
                ];
            }
        },
    },

    methods: {
        ...mapActions('stockCheck', [
            'removeCountedStock',
            'addCountedStock',
            'updateCountedStock',
            'saveStockVariance',
            'removeStockVariance',
        ]),

        onSelectStock(stockInventory) {
            if (this.findStockIndex(stockInventory.stock_id) >= 0) {
                $(`#quantity_${stockInventory.stock_id}`).focus();
            } else {
                this.addCountedStock({ stockInventory });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_check/stock-check-edit-stocks.vue